module.exports = __webpack_public_path__ + "static/media/event-splash.ad8c5ef4.JPG";